/* =============================================================================
   PRUNEX 1 — LANDING NUTRADEY
   TODOS LOS TEXTOS, ENLACES E IMÁGENES DE LA PÁGINA VIVEN EN ESTE ARCHIVO.
   Editá acá sin tocar el código de los componentes.
   ============================================================================= */

// ---------------------------------------------------------------- WHATSAPP ---
export const WA_PHONE = "50488889851";

// Mensaje distinto por botón + UTM para medir qué sección convierte más
export const WA_BUTTONS = {
  hero: {
    msg: "Hola, vi la página de Prunex. Quiero saber si es para mi caso.",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "hero" },
    label: "Escribime y te digo si es para vos",
  },
  diagnostico: {
    msg: "Hola, marqué varios síntomas en tu página. Te cuento mi caso.",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "diagnostico" },
    label: "Contame tu caso",
  },
  metodo: {
    msg: "Hola, me interesa el Método de las 5 Noches. ¿Cómo arranco?",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "metodo5noches" },
    label: "Quiero arrancar esta noche",
  },
  oferta: {
    msg: "Hola, quiero la caja de Prunex y el acompañamiento. ¿Cómo hacemos?",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "oferta" },
    label: "Escribime y arrancamos esta noche",
  },
  cierre: {
    msg: "Hola, te cuento mi caso a ver si esto me sirve...",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "cierre" },
    label: "Contame tu caso",
  },
  flotante: {
    msg: "Hola, tengo una pregunta sobre Prunex.",
    utm: { source: "landing", medium: "cta", campaign: "prunex1", content: "boton_flotante" },
    label: "Escribime — te contesto yo",
  },
};

// -------------------------------------------------------------- META PIXEL ---
// Pegá acá el ID del píxel cuando lo tengás. Si queda vacío, no se carga nada.
export const META_PIXEL_ID = "";
export const META_EVENT_NAME = "ClicWhatsApp";

// ----------------------------------------------------------------- MARCA -----
export const BRAND = {
  asesor: "Nutradey",
  ciudad: "Tegucigalpa",
  telefonoVisible: "+504 8888-9851",
  logoNutradey:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_207fdd24-29d5-4f06-b978-259fc80ac2a1/artifacts/m3p8ssem_nutradey%20logo%20sin%20fondo.png",
  logoNutradeyBlanco:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_207fdd24-29d5-4f06-b978-259fc80ac2a1/artifacts/akxxb0f2_nutradey%20logo%20blanco%20sin%20fondo.png",
  logoFuxion:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_207fdd24-29d5-4f06-b978-259fc80ac2a1/artifacts/9tp9cg0n_fuzion%20logo%20sin%20fondo%20-%20azul.png",
  isotipoFuxion:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_207fdd24-29d5-4f06-b978-259fc80ac2a1/artifacts/ljaguavm_isotipo%20fuxion.png",
  isotipoFuxionBlanco:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_207fdd24-29d5-4f06-b978-259fc80ac2a1/artifacts/5zlggb53_isotipo%20fuxion%20blanco.png",
};

// -------------------------------------------------------------- IMÁGENES -----
// Reemplazá estas URLs por las fotos definitivas cuando las tengás.
export const IMAGES = {
  // Producto (PNG recortado sin fondo, convertido a WebP)
  productoBolsa: "/img/prunex-bolsa.webp",
  productoStick: "/img/prunex-stick.webp",
  // Antes / después (null = placeholder ilustrativo)
  antes: "/img/antes.webp?v=2",
  despues: "/img/despues.webp?v=2",
  // Decorativos
  ciruelas:
    "https://images.unsplash.com/photo-1630754327308-1cf2af7769e4?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  anis:
    "https://images.pexels.com/photos/11000784/pexels-photo-11000784.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=400",
  asesor:
    "https://images.unsplash.com/photo-1627754939597-ba460af0844f?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
};

// ------------------------------------------------------ 1. BARRA SUPERIOR ----
export const TOPBAR_ITEMS = [
  { icon: "MapPin", text: "Entrega hoy en Tegucigalpa" },
  { icon: "Truck", text: "Envío a todo Honduras" },
  { icon: "CheckCircle2", text: "Producto original FuXion\u00ae" },
];

export const HEADER = {
  claim: "Distribuidor independiente autorizado",
};

// -------------------------------------------------------------- 2. HERO ------
export const HERO = {
  badge: "Fórmula natural · 6 ingredientes",
  h1: [
    { text: "No estás gorda.", color: "vino" },
    { text: "Estás ", color: "vino", inline: true },
    { text: "inflamada", color: "lima", inline: true },
    { text: ".", color: "vino", inline: true },
    { text: "Y eso se arregla en 5 noches.", color: "vino" },
  ],
  sub: "Un sobre de Prunex 1 antes de dormir. Sin cólicos, sin dietas, sin vivir pegado al baño.",
  micro: "Te contesto yo, no un bot · Respuesta en menos de 1 hora",
  badgeCircular: { top: "28", bottom: "STICKS" },
  stats: [
    { icon: "Moon", value: 5, prefix: "", suffix: "", label: "Noches para notarlo" },
    { icon: "Users", value: 180, prefix: "+", suffix: "", label: "Personas acompañadas" },
    { icon: "Leaf", value: 100, prefix: "", suffix: "%", label: "Ingredientes naturales" },
    { icon: "Zap", value: 1, prefix: "", suffix: "ª", label: "Mañana ya se siente" },
  ],
};

// ------------------------------------------------------- 3. DIAGNÓSTICO ------
export const DIAGNOSTICO = {
  h2: "¿Reconocés alguno de estos?",
  sub: "Marcá los que te pasan.",
  items: [
    { id: "panza", icon: "CircleDashed", text: "Panza hinchada todo el día" },
    { id: "bano", icon: "CalendarX", text: "Voy al baño cada 2–3 días" },
    { id: "pantalon", icon: "Shirt", text: "El pantalón me aprieta en la tarde" },
    { id: "gases", icon: "Wind", text: "Gases y pesadez" },
    { id: "energia", icon: "BatteryLow", text: "Me siento lento y sin energía" },
    { id: "humor", icon: "Frown", text: "Mal humor y digestión lenta" },
  ],
  resultadoTitulo: (n) => `Marcaste ${n} de 6.`,
  resultadoTexto:
    "Tu intestino te está pidiendo ayuda. Lo bueno: es de lo más fácil de arreglar.",
};

// ---------------------------------------------------------- 4. DIAGRAMA ------
export const DIAGRAMA = {
  h2: "Tu intestino no está dañado. Está seco y sin volumen.",
  colA: {
    titulo: "Tránsito lento",
    pasos: [
      { icon: "DropletOff", text: "Poca fibra y poca agua" },
      { icon: "MinusCircle", text: "El desecho se compacta y se seca" },
      { icon: "AlertCircle", text: "Se queda, fermenta y te inflama" },
    ],
  },
  colB: {
    titulo: "Con el Método de las 5 Noches",
    pasos: [
      { icon: "Droplets", text: "La fibra absorbe agua y forma un gel suave" },
      { icon: "MoveRight", text: "Da volumen y lubrica: todo se desliza" },
      { icon: "Sparkles", text: "La inulina alimenta tu flora buena" },
    ],
  },
  ancla: { a: "No empuja.", b: "REORDENA." },
};

// ----------------------------------------------------------- 5. MÉTODO ------
export const METODO = {
  badge: "Toma 2 minutos al día",
  h2: "El Método de las 5 Noches",
  pasos: [
    {
      num: "01",
      icon: "MoonStar",
      titulo: "La noche",
      text: "Un stick en 180ml de agua caliente. Sabe a ciruela.",
    },
    {
      num: "02",
      icon: "Hourglass",
      titulo: "Mientras dormís",
      text: "La fibra forma gel. Nada te despierta. Cero cólicos.",
    },
    {
      num: "03",
      icon: "Sunrise",
      titulo: "La mañana",
      text: "Tu cuerpo hace lo suyo, con calma. Repetís 5 noches.",
    },
  ],
  destacada: "Después: 1 stick cada 3–4 días para mantener el ritmo.",
};

// --------------------------------------------------- 6. ANTES Y DESPUÉS -----
export const ANTES_DESPUES = {
  h2: "Así se siente el día 6",
  sub: "La diferencia no es de peso. Es de hinchazón.",
  labelAntes: "ANTES",
  labelDespues: "DESPUÉS",
  hint: "Arrastrá para comparar",
  cambios: [
    { icon: "Shirt", text: "La ropa te queda más cómoda" },
    { icon: "Feather", text: "Te sentís liviano todo el día" },
    { icon: "Smile", text: "Volvés a estar cómodo en las fotos" },
  ],
  aviso:
    "Imágenes ilustrativas de la reducción de hinchazón abdominal. Los resultados varían según cada persona. Prunex 1 no es un producto para bajar de peso.",
};

// ------------------------------------------------------- 7. COMPARATIVA -----
export const COMPARATIVA = {
  h2: "La diferencia, sin adornos",
  badgeRecomendado: "RECOMENDADO",
  columnas: ["Té de sena / laxante", "Fibra en polvo", "PRUNEX 1"],
  filas: [
    {
      criterio: "Cómo actúa",
      a: { t: "Irrita para forzar", i: "neutral" },
      b: { t: "Solo da volumen", i: "neutral" },
      c: { t: "Volumen + lubricación + prebiótico", i: "check" },
    },
    {
      criterio: "Cólicos",
      a: { t: "Frecuentes", i: "warn" },
      b: { t: "Raros", i: "neutralCheck" },
      c: { t: "No es su efecto", i: "check" },
    },
    {
      criterio: "Alimenta tu flora",
      a: { t: "No", i: "x" },
      b: { t: "No", i: "x" },
      c: { t: "Sí — inulina", i: "check" },
    },
    {
      criterio: "Sabor",
      a: { t: "Amargo", i: "x" },
      b: { t: "Arenoso", i: "x" },
      c: { t: "Ciruela", i: "check" },
    },
    {
      criterio: "Cuándo se toma",
      a: { t: "Variable", i: "neutral" },
      b: { t: "Con cada comida", i: "neutral" },
      c: { t: "1 vez, antes de dormir", i: "check" },
    },
    {
      criterio: "Uso continuo",
      a: { t: "Genera tolerancia", i: "warn" },
      b: { t: "Diario obligatorio", i: "neutral" },
      c: { t: "Cada 3–4 días", i: "check" },
    },
  ],
};

// ------------------------------------------------------ 8. INGREDIENTES -----
export const INGREDIENTES = {
  h2a: "6 ingredientes.",
  h2b: "Ninguno inventado en un laboratorio.",
  hint: "Tocá una tarjeta para ver el detalle",
  items: [
    {
      nombre: "Psyllium",
      linea: "La escoba suave que barre sin raspar",
      detalle:
        "Su cáscara absorbe hasta 10 veces su peso en agua y se convierte en un gel. No raspa la pared del intestino, la recubre.",
      img: "https://images.pexels.com/photos/5078582/pexels-photo-5078582.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=400",
    },
    {
      nombre: "Inulina de achicoria",
      linea: "Prebiótico: alimenta tus bacterias buenas",
      detalle:
        "No la digerís vos, la comen tus bacterias buenas. Cuando ellas están fuertes, tu digestión se ordena sola.",
      img: "https://images.pexels.com/photos/3036370/pexels-photo-3036370.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=400",
    },
    {
      nombre: "Mucílago de linaza",
      linea: "Lubrica para que todo se deslice",
      detalle:
        "Es la parte gelatinosa de la semilla. Hace de lubricante natural: por eso no hay esfuerzo ni ardor.",
      img: "https://images.pexels.com/photos/7420738/pexels-photo-7420738.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=400",
    },
    {
      nombre: "Guindón (ciruela)",
      linea: "El remedio de tu abuela, concentrado",
      detalle:
        "Aporta sorbitol y el sabor dulce de la bebida. Es lo que tu abuela ya sabía, pero en dosis medida.",
      img: "https://images.unsplash.com/photo-1630754327308-1cf2af7769e4?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    },
    {
      nombre: "Kelp",
      linea: "Alga marina rica en minerales",
      detalle:
        "Suma minerales traza al preparado. Contiene yodo: por eso avisamos si tenés tema de tiroides.",
      img: "https://images.unsplash.com/photo-1567001847230-ed5da95bd055?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    },
    {
      nombre: "Anís estrella",
      linea: "Menos gases, menos pesadez",
      detalle:
        "Carminativo de toda la vida: ayuda a que el gas salga en lugar de quedarse apretando.",
      img: "https://images.unsplash.com/photo-1554345795-1243a276630e?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    },
  ],
};

// ------------------------------------------------------- 9. TESTIMONIOS -----
export const TESTIMONIOS = {
  h2: "Lo que me escribieron al sexto día",
  sub: "Capturas reales. Con permiso de cada persona.",
  badge: "Cliente verificada",
  badgeM: "Cliente verificado",
  items: [
    {
      nombre: "Karla M.",
      ciudad: "Comayagüela",
      edad: 38,
      genero: "f",
      texto:
        "Pensé que era otro té de esos que te dan cólico. A la tercera mañana ya notaba la diferencia. Volví a usar mis jeans de siempre.",
      foto:
        "https://images.unsplash.com/photo-1643236007972-8e89e21b637e?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
    },
    {
      nombre: "Don Rigoberto",
      ciudad: "Tegucigalpa",
      edad: 61,
      genero: "m",
      texto:
        "A mi edad ya me había resignado. No me da cólico, esa es la diferencia con todo lo que había probado.",
      foto:
        "https://images.pexels.com/photos/11433115/pexels-photo-11433115.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=200",
    },
    {
      nombre: "Javier A.",
      ciudad: "San Pedro Sula",
      edad: 44,
      genero: "m",
      texto:
        "Yo no creo en estas cosas. Lo tomé por insistencia de mi esposa. Al quinto día dejé de sentirme pesado después del almuerzo.",
      foto:
        "https://images.unsplash.com/photo-1652883254451-a7c2b94cc35b?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
    },
    {
      nombre: "Ana Lucía",
      ciudad: "Comayagua",
      edad: 33,
      genero: "f",
      texto:
        "Después de mi segundo embarazo todo se puso lento. La primera noche casi no lo tomo por flojera. Menos mal que sí.",
      foto:
        "https://images.unsplash.com/photo-1772989665252-7cb41ae759cc?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
    },
    {
      nombre: "Marleny R.",
      ciudad: "Choluteca",
      edad: 47,
      genero: "f",
      texto:
        "Lo que más me gustó es que él me escribía cada dos días a preguntarme cómo iba. Eso nadie lo hace.",
      foto:
        "https://images.pexels.com/photos/12649481/pexels-photo-12649481.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=200",
    },
    {
      nombre: "Kevin O.",
      ciudad: "Tegucigalpa",
      edad: 29,
      genero: "m",
      texto:
        "Entreno seis días a la semana y andaba inflamado igual. Esto me arregló lo que la dieta no.",
      foto:
        "https://images.unsplash.com/photo-1732464517760-ca7a7be3cc76?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
    },
  ],
  // Capturas de WhatsApp ilustradas (nombres difuminados)
  chats: [
    {
      nombre: "Karla M.",
      hora: "6:12 a.m.",
      burbujas: [
        { de: "ella", t: "Buenos días! No lo puedo creer 😅" },
        { de: "ella", t: "Hoy me desperté sin la panza dura" },
        { de: "yo", t: "Te dije 🙌 seguí las 5 noches completas" },
      ],
    },
    {
      nombre: "Javier A.",
      hora: "9:40 p.m.",
      burbujas: [
        { de: "el", t: "Día 5. Cero pesadez después del almuerzo" },
        { de: "yo", t: "Perfecto. Ahora pasamos a cada 3 días" },
        { de: "el", t: "Va. Gracias por el seguimiento" },
      ],
    },
    {
      nombre: "Marleny R.",
      hora: "7:03 a.m.",
      burbujas: [
        { de: "ella", t: "Ya bajó la hinchazón de la tarde" },
        { de: "ella", t: "El pantalón me cierra tranquilo" },
        { de: "yo", t: "Buenísimo 💪 seguí con el agua" },
      ],
    },
  ],
};

// ---------------------------------------------------------- 10. OFERTA ------
export const OFERTA = {
  badge: "Solo 15 cupos por semana",
  h2: "Esto es lo que recibís",
  items: [
    { text: "Prunex 1 — 28 sticks. Arranque + todo el mes", valor: "—" },
    { text: 'Guía "Las 5 Noches" en PDF', valor: "L 350" },
    { text: "Acompañamiento por WhatsApp, 30 días", valor: "L 600" },
    { text: "Checklist: los 7 errores que anulan el efecto", valor: "L 200" },
    { text: "Recetario de 10 desayunos livianos", valor: "L 250" },
    { text: "Entrega a domicilio en Tegucigalpa", valor: "—" },
  ],
  cierreValor: "Valor del acompañamiento: L 1,400",
  cierreLinea: "Vos pagás solo la caja.",
  cierreFrase: "No me interesa venderte una caja. Me interesa que te funcione.",
  micro: "Sin llamadas · Sin insistir · Sin meterte a ningún grupo",
};

// ------------------------------------------------------ 11. NO ES PARA ------
export const NO_ES_PARA = {
  h2: "Te ahorro el dinero: esto no es para todos.",
  items: [
    "Si estás embarazada o dando pecho — consultá a tu médico primero",
    "Si tenés problemas de tiroides o tomás medicamento para tiroides (Prunex lleva kelp, que aporta yodo)",
    "Si tenés una condición digestiva diagnosticada o estás en tratamiento",
    "Si buscás bajar 20 libras. Esto no es para bajar de peso.",
    "Si no vas a tomar suficiente agua — sin agua, la fibra no funciona",
  ],
  cierre: "Si nada de esto te aplica: escribime.",
};

// ------------------------------------------------------------- 12. FAQ ------
export const FAQ = {
  h2: "Preguntas frecuentes",
  items: [
    {
      q: "¿Me va a dar diarrea o cólicos?",
      a: "No es un laxante irritante. Forma volumen y lubrica. Si sos muy sensible arrancamos con medio stick — te explico cómo.",
    },
    {
      q: "¿Tengo que hacer dieta?",
      a: "No. Solo tomar suficiente agua. Si además comés mejor, mejor te va.",
    },
    {
      q: "¿A qué sabe?",
      a: "A ciruela dulce y caliente. Casi todos se sorprenden de que sea rico.",
    },
    {
      q: "¿En cuánto tiempo lo siento?",
      a: "La primera señal, a la mañana siguiente. La sensación de estar desinflamado, entre el día 3 y el 5.",
    },
    {
      q: "¿Voy a bajar de peso?",
      a: "No te lo voy a vender así. Lo que sí vas a sentir es menos hinchazón y la ropa más cómoda. Eso es desinflamarse, no perder grasa.",
    },
    {
      q: "¿Crea dependencia?",
      a: "No actúa irritando el intestino, que es lo que genera dependencia en los laxantes comunes.",
    },
    {
      q: "¿Esto es multinivel? ¿Me vas a querer meter al negocio?",
      a: "Soy distribuidor independiente de FuXion, sí. Y no, no te voy a invitar a nada ni a ningún grupo.",
    },
    {
      q: "¿Cómo pago y cómo me llega?",
      a: "Transferencia, efectivo contra entrega en Tegucigalpa, o envío con guía al resto del país. Lo vemos por WhatsApp.",
    },
  ],
};

// ----------------------------------------------------------- 13. CIERRE -----
export const CIERRE = {
  h2: "Son cinco noches. Nada más.",
  parrafos: [
    "Si funciona, lo sabés el sábado en la mañana. Si no funciona, perdiste cinco noches tomando algo que sabe rico.",
    "Lo que no me parece justo es que sigás otro año acomodándote la ropa para disimular, sin siquiera haberlo intentado.",
  ],
  firma: (nombre, ciudad) =>
    `— ${nombre}, distribuidor independiente FuXion\u00ae · ${ciudad}`,
};

// ------------------------------------------------------------- FOOTER -------
export const FOOTER = {
  legal:
    "Prunex 1 es un alimento funcional. No es un medicamento y no está destinado a diagnosticar, tratar, curar ni prevenir ninguna enfermedad. Los resultados varían de una persona a otra. Consultá a tu médico antes de consumirlo si estás embarazada o lactando, si tenés alguna condición de tiroides o tomás medicamento para tiroides (este producto contiene kelp, fuente de yodo), o si estás bajo tratamiento médico. No recomendado para menores de edad. Acompañá su consumo con abundante agua.",
  disclaimer:
    "Soy distribuidor independiente autorizado de FuXion\u00ae. Esta no es una página oficial de la empresa.",
  copy: "© 2026 · WhatsApp: +504 8888-9851",
};
